import { render, staticRenderFns } from "./UserNotAllowed.vue?vue&type=template&id=9dbc1722&"
import script from "./UserNotAllowed.vue?vue&type=script&lang=js&"
export * from "./UserNotAllowed.vue?vue&type=script&lang=js&"
import style0 from "./UserNotAllowed.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports